<template>

  <div>

    <t-input-code-label-list
        v-if="mount" :show="modalSearch"
        :entity-page-id="entityPageId"
        :entity-path="entityPath"
        :code-label-key-column="codeLabelKeyColumn"
        :primary-key-column="primaryKeyColumn"
        :enable-import-model="enableImportModel"
        :add-search-params-default="localAddSearchParamsDefault"
        :block-enterprise-id="blockEnterpriseId"
        :title-items="titleItems"
        :type="type"
        :label="label"
        @onClose="onModalSearchClose()" @onSelected="onSelected"/>

    <div class="d-flex align-items-start">

      <t-input @focusin="searchFocusIn" upper not-autocomplete @keyup.native="executeFastSearch"
               @focusout="searchFocusOut" :add-error="addError"
               :fixed="localFixed"
               :form-status="status" :form-command="command" :required="required" class-input="input-with-search"
               :label="label"
               :hide-label="hideLabel"
               v-model="codeLabel">

        <template #input-group-append v-if="!localFixed">

          <div style="position: absolute; left: -2px; top: 35px; /*background-color: #8b1833*/">

            <div tabindex="-1" :class="{'show':fastSearchList.length > 0}"
                 class="rm-pointers dropdown-menu dropdown-menu-left not-transform" style="min-width: 200px;">

              <button type="button" v-for="(item,index) in fastSearchList" :key="index" tabindex="0"
                      @click="setFastSearchByIndex(index)" :class="{'item-dropdown-select': index === fastSearchCursor}"
                      class="dropdown-item one-per-line">


                <div v-html="getDetailSearchList(item)"></div>

              </button>

            </div>

          </div>

          <b-button
              variant="outline-secondary"
              v-if="command === 'insert' || command === 'update'"
              :id="btnSearchId"
              @click="openModalSearch"
          >
            <b-icon-search/>
          </b-button>

        </template>

      </t-input>


      <b-col class="text-left" v-if="!disableName" style="padding-right: 0px;margin-top: 22px"
             :class="{'description-input-code-label-hide-label':hideLabel}">

        <div class="vs--disabled_label form-control"
             style="margin-bottom: 8px; text-overflow: ellipsis; overflow: hidden; height: 33px !important">
          <span>{{ name }}</span>
        </div>

      </b-col>

    </div>

  </div>

</template>
<script>
import tInputCodeLabelList from "@/components/template/form/finder/t-input-code-label-list";
import pageInputSearchInputMixin from "@/mixins/page/pageInputSearchInputMixin";
import ui from "@/assets/scripts/ui";

export default {
  name: 't-input-code-label',
  components: {tInputCodeLabelList},
  mixins: [pageInputSearchInputMixin],
  data() {
    return {
      modalId: "modal-code-label-search",//Será complementado com a coluna codeLabel para diferenciar quando usado vários na mesma tela
      entityPageId: 0, //Pagina original sem override de acordo com o tipo informado
      entityPath: "",
      label: "",
      titleItems: "",
      type: "",
      localAddSearchParamsDefault: [],
      accountModule: "",
    }
  },
  props: {
    btnSearchId: { /*Usado quando desejar manipular o botão search por fora*/
      type: String,
      default: '',
    },
    model: Boolean,
    material: Boolean,
    compound: Boolean,
    machine: Boolean,
    rawMaterial: Boolean,
    instrument: Boolean,
    component: Boolean,
    enterprise: Boolean,
    spotFolder: Boolean,
    environment: Boolean,
    occurrence: Boolean,
    production: Boolean,
    inspector: Boolean,
    typePathology: Boolean,
    typeBuildingMaterial: Boolean,
    typeEquipment: Boolean,
    typeChecklistItem: Boolean,
    enableImportModel: Boolean,
    lot: Boolean,
    addSearchParamsDefault: {
      type: Array,
      default: () => [], // Usar uma função para garantir que cada instância receba um novo array
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {

    /*ATENÇÃO POR CONSISTÊNCIA O USUÁRIO DEVERÁ TER PELO MENOS A VALIDAÇÃO DE ACESSO GERAL A PÁGINA, POIS NA PRÁTICA AS MESMAS INFORMAÇÕES EXIBIDAS SÃO LISTADAS*/
    this.accountModule = ui.getAccountModule()

    this.localAddSearchParamsDefault = this.addSearchParamsDefault

    if (this.model) {
      this.entityPageId = 8
      this.primaryKeyColumn = "modelId"
      this.codeLabelKeyColumn = "modelCodeLabel"
      this.entityPath = "product/model"
      this.label = "Modelo"
      this.titleItems = "Modelos"
      this.type = "model"
    } else if (this.material) {
      this.entityPageId = 136
      this.primaryKeyColumn = "materialId"
      this.codeLabelKeyColumn = "materialCodeLabel"
      this.entityPath = "product/material"
      this.label = "Material"
      this.titleItems = "Materiais"
      this.type = "material"
    } else if (this.compound) {
      this.entityPageId = 134
      this.primaryKeyColumn = "compoundId"
      this.codeLabelKeyColumn = "compoundCodeLabel"
      this.entityPath = "product/compound"
      this.label = "Composto"
      this.titleItems = "Compostos"
      this.type = "compound"
    } else if (this.machine) {
      this.entityPageId = 55
      this.primaryKeyColumn = "machineId"
      this.codeLabelKeyColumn = "machineCodeLabel"
      this.entityPath = "production/machine"
      this.label = "Máquina"
      this.titleItems = "Máquinas"
      this.type = "machine"
    } else if (this.rawMaterial) {
      this.entityPageId = 20
      this.primaryKeyColumn = "rawMaterialId"
      this.codeLabelKeyColumn = "rawMaterialCodeLabel"
      this.entityPath = "product/raw-material"
      this.label = "Matéria-Prima"
      this.titleItems = "Matérias-Prima"
      this.type = "rawMaterial"
    } else if (this.instrument) {
      this.entityPageId = 165
      this.primaryKeyColumn = "instrumentId"
      this.codeLabelKeyColumn = "instrumentCodeLabel"
      this.entityPath = "production/instrument"
      this.label = "Instrumento"
      this.titleItems = "Instrumentos"
      this.type = "instrument"
    } else if (this.component) {
      this.entityPageId = 52
      this.primaryKeyColumn = "componentId"
      this.codeLabelKeyColumn = "componentCodeLabel"
      this.entityPath = "product/component"
      this.label = "Componente"
      this.titleItems = "Componentes"
      this.type = "component"
    } else if (this.enterprise) {
      this.entityPageId = 192
      this.primaryKeyColumn = "enterpriseId"
      this.codeLabelKeyColumn = "enterpriseCodeLabel"
      this.entityPath = "place/enterprise"
      this.label = "Empreendimento"
      this.titleItems = "Empreendimentos"
      this.type = "enterprise"
      this.localAddSearchParamsDefault.push({'modelEnterprise': 'false'})
    } else if (this.spotFolder) {
      this.entityPageId = 196
      this.primaryKeyColumn = "spotFolderId"
      this.codeLabelKeyColumn = "spotFolderCodeLabel"
      this.entityPath = "place/spot-folder"
      this.label = "Pavimento"
      this.titleItems = "Pavimentos"
      this.type = "spotFolder"
    } else if (this.environment) {
      this.entityPageId = 197
      this.primaryKeyColumn = "environmentId"
      this.codeLabelKeyColumn = "environmentCodeLabel"
      this.entityPath = "place/environment"
      this.label = "Ambiente"
      this.titleItems = "ambientes"
      this.type = "environment"
    } else if (this.occurrence) {
      this.entityPageId = 211
      this.primaryKeyColumn = "occurrenceId"
      this.codeLabelKeyColumn = "occurrenceCodeLabel"
      this.entityPath = "checklist/occurrence"
      this.label = "Apontamento"
      this.titleItems = "apontamentos"
      this.type = "occurrence"
    } else if (this.inspector) {
      this.entityPageId = 195
      this.primaryKeyColumn = "inspectorId"
      this.codeLabelKeyColumn = "inspectorCodeLabel"
      this.entityPath = "agent/inspector"
      this.label = "Inspetor"
      this.titleItems = "Inspetores"
      this.type = "inspector"
    } else if (this.typeChecklistItem) {
      this.entityPageId = 189
      this.primaryKeyColumn = "typeChecklistItemId"
      this.codeLabelKeyColumn = "typeChecklistItemCodeLabel"
      this.entityPath = "checklist/type-item"
      this.label = "Item"
      this.titleItems = "Itens"
      this.type = "typeChecklistItem"
    } else if (this.typePathology) {
      this.entityPageId = 190
      this.primaryKeyColumn = "typePathologyId"
      this.codeLabelKeyColumn = "typePathologyCodeLabel"
      this.entityPath = "checklist/type-pathology"
      this.label = "Anomalia"
      this.titleItems = "Anomalias"
      this.type = "typePathology"
    } else if (this.typeBuildingMaterial) {
      this.entityPageId = 267
      this.primaryKeyColumn = "typeBuildingMaterialId"
      this.codeLabelKeyColumn = "typeBuildingMaterialCodeLabel"
      this.entityPath = "product/type-building-material"
      this.label = "Material"
      this.titleItems = "Materiais"
      this.type = "typeBuildingMaterial"
    } else if (this.typeEquipment) {
      this.entityPageId = 268
      this.primaryKeyColumn = "typeEquipmentId"
      this.codeLabelKeyColumn = "typeEquipmentCodeLabel"
      this.entityPath = "product/type-equipment"
      this.label = "Equipamento"
      this.titleItems = "Equipamentos"
      this.type = "typeEquipment"
    } else if (this.lot) {
      this.entityPageId = 104
      this.primaryKeyColumn = "lotId"
      this.codeLabelKeyColumn = "lotCodeLabel"
      this.entityPath = "production/lot"
      this.label = "Lote"
      this.titleItems = "Lotes"
      this.type = "lot"
    } else if(this.production){
      this.entityPageId = 56
      this.primaryKeyColumn = "productionOrderId"
      this.codeLabelKeyColumn = "productionOrderCodeLabel"
      this.entityPath = "production/order"
      this.label = "Ordem Fabr."
      this.titleItems = "Ordens"
      this.type = "productionOrder"

    }

    if(this.enterprise && this.accountModule === 'estate'){
      this.label = "Imóvel"
      this.titleItems = "Imóveis"
    }

    this.modalId += '-' + this.codeLabelKeyColumn
    this.path = this.entityPath

  },
  methods: {

    async getResume(exportId) {

      if (exportId === 0) {
        this.codeLabel = ""
        this.name = ""
      } else {

        this.busy = true

        setTimeout(async () => {

          await this.getResumeCodeLabel('id', exportId).then(() => {
            this.setBlackout(false)
          })

        }, 100)

      }

    },

  },
  watch: {
    async value(v) {
      await this.getResume(v)
      this.$emit("change", v)
    },
  },

}
</script>